import api from "./api";

class ProvinciaManager {

    province(config?: any) {
        return api.get(`/province`, config)
    }

    provincia(id: number | string) {
        return api.get(`/province/${id}`)
    }

    retrieve = this.provincia
    list = this.province
}

class ComuneManager {

    comuni(config?: any) {
        return api.get(`/comuni`, config)
    }

    comune(id: number | string) {
        return api.get(`/comuni/${id}`)
    }

    retrieve = this.comune
    list = this.comuni
}

class NazioneManager {

    nazioni(config?: any) {
        return api.get(`/nazioni`, config)
    }

    nazione(id: number | string) {
        return api.get(`/nazioni/${id}`)
    }

    retrieve = this.nazione
    list = this.nazioni
}

class FilterNazioneManager {

    async nazioni(config?: any) {
        let response = await api.get(`/nazioni`, config)
        // add custom items here
        response.data.unshift({id: -1, nome: "Tutte le nazioni"})
        response.data.unshift({id: -2, nome: "Tutte le nazioni estere"})
        return response
    }

    nazione(id: number | string) {
        return api.get(`/nazioni/${id}`)
    }

    retrieveAll(ids: number[]) {
        if (ids[0] === -1) {
            return Promise.resolve({data: [{id: -1, nome: "Tutte le nazioni"}]});
        }
        if (ids[0] === -2) {
            return Promise.resolve({data: [{id: -2, nome: "Tutte le nazioni estere"}]});
        }
        return api.get(`/nazioni/ids`, {params: {ids}})
    }

    retrieve = this.nazione
    list = this.nazioni
}

const provinciaManager = new ProvinciaManager()
const nazioneManager = new NazioneManager()
const comuneManager = new ComuneManager()

const filterNazioneManager = new FilterNazioneManager()

export {provinciaManager, comuneManager, nazioneManager, filterNazioneManager}
